
	import { defineComponent, ref } from 'vue';
	import { IonApp, IonRouterOutlet } from '@ionic/vue';
	import { ellipse, square, triangle } from 'ionicons/icons';
	import Header from '@/components/Header.vue';
	import SideMenu from '@/components/SideMenu.vue';
	// import InjectFirebase from '@/components/InjectFirebase.vue';
	import IntroPage from '@/views/IntroPage.vue';
	import LoginPage from '@/views/LoginPage.vue';
	import Printer from './utils/Printer';
	import SocketService from './services/socket.service';
	import { useScannerDetection } from '@/utils/ScannerDetection';
	import { useI18n } from 'vue-i18n';
	import moment from 'moment-timezone';
	var translate;
	var scannerHandled = false;
	export default defineComponent({
		name: 'App',
		components: { Header, SideMenu, IonRouterOutlet, IonApp, IntroPage, LoginPage },
		setup(props, context) {
			const toggleDarkTheme = (shouldAdd: boolean) =>
			{
				document.body.classList.toggle('dark', shouldAdd);
				localStorage.setItem('dark', shouldAdd ? 'true' : 'false');
			};
			let localDarkMode = localStorage.getItem('dark');
			if(localDarkMode != null)
			{
				toggleDarkTheme(localDarkMode == 'true');
			}
			else
			{
				const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
				toggleDarkTheme(prefersDark.matches);
				prefersDark.addListener((mediaQuery) => toggleDarkTheme(mediaQuery.matches));
			}
			const showIntroPage = false;//!(localStorage.getItem('skip_intro') == '1');
			const options = {
				timeBeforeScanTest	: 100,
				avgTimeByChar		: 30,
				preventDefault		: false,
				endChar				: [13],
				minLength 			: 4,
				onComplete: (scannedString) => {
					context.emit('scanner_raw', scannedString);
				}
			};
			const { initScannerDetection/*, scannerDetectionTest*/ } = useScannerDetection(options);
			//
			return {
				ellipse,
				square,
				triangle,
				showIntroPage,
				initScannerDetection
			}
		},
		mounted()
		{
			//@ts-ignore
			this.$root.$on('scanner_raw', (scannedString) => {
				scannerHandled = false;
				//@ts-ignore
				this.$eventBus.emit('scanner', scannedString);
				console.log('Scanned:', scannedString, scannerHandled);
				if (scannerHandled == false) {
					//Get the access card from API and open it...
				}
			});
			this.createTranslator();
			//@ts-ignore
			this.$root.printer = new Printer(this.$store, translate);
			//@ts-ignore
			this.$root.printer.BindListeners();
		},
		watch: {
			'$store.state.auth.user': {
				handler(newVal, oldVal) {
					if (typeof newVal != 'undefined' && newVal != null) {
						//@ts-ignore
						if (typeof this.$root.socket == 'undefined' || this.$root.socket == null) {
							//@ts-ignore
							this.$root.socket = new SocketService();
							//@ts-ignore
							this.$root.socket.initialize(this);
							//@ts-ignore
							this.$root.permissions = this.$store.state.auth.role == null ? null : JSON.parse(this.$store.state.auth.role.permissions);
							//@ts-ignore
							this.$root.hasPermission = function(permission_name)
							{
								//@ts-ignore
								if (this.$root.permissions == null && this.$store.state.auth.role != null) {
									//@ts-ignore
									this.$store.state.auth.role = JSON.parse(this.$store.state.auth.role.permissions);
								//@ts-ignore
								} else if (this.$root.permissions == null) {
									return false;
								}
								//@ts-ignore
								var permissions = this.$root.permissions;
								if (typeof permissions != 'undefined' && typeof permissions[permission_name] != 'undefined')
								{
									return permissions[permission_name];
								}
								return false;
							}
							//@ts-ignore
							this.$root.fastConnection = function()
							{
								if ('connection' in navigator || 'mozConnection' in navigator || 'webkitConnection' in navigator) {
									//@ts-ignore
									const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
									//@ts-ignore
									// console.log('Network type:', connection.effectiveType);  // e.g., '4g', '3g'
									//@ts-ignore
									// console.log('Downlink speed (Mbps):', connection.downlink);  // e.g., 1.2 Mbps
									//@ts-ignore
									// console.log('Round-trip time (ms):', connection.rtt);  // e.g., 50 ms
									//@ts-ignore
									if (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g') {
										// console.log('Network is slow');
									//@ts-ignore
									} else if (connection.effectiveType === '3g') {
										// console.log('Network is average speed');
									} else {
										// console.log('Network is fast');
										return true;
									}
								} else {
									console.log('Network Information API is not supported in this browser.');
								}
								return false;
							}
							//@ts-ignore
							this.$root.setScannerHandled = function(handled) {
								//@ts-ignore
								scannerHandled = handled;
							}
						}
					}
				},
				immediate: true, // Fires the watcher immediately with the current value
				deep: true // Optional: watches nested properties
			}
		},
		computed:
		{
			currentUser()
			{
				//@ts-ignore
				return this.$store.state.auth.user;
			}
		},
		methods: {
			createTranslator()
			{
				var { t } = useI18n({
					inheritLocale: false,
					useScope: 'global',
					locale: 'fr'
				});
				translate = t;
			}
		}
	});
